"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextType = exports.TextLineHeight = exports.TextSize = exports.TextWeight = void 0;
var TextWeight;
(function (TextWeight) {
    TextWeight["bold"] = "bold";
    TextWeight["light"] = "light";
    TextWeight["regular"] = "regular";
})(TextWeight || (exports.TextWeight = TextWeight = {}));
var TextSize;
(function (TextSize) {
    TextSize[TextSize["TextSize10"] = 10] = "TextSize10";
    TextSize[TextSize["TextSize12"] = 12] = "TextSize12";
    TextSize[TextSize["TextSize14"] = 14] = "TextSize14";
    TextSize[TextSize["TextSize16"] = 16] = "TextSize16";
    TextSize[TextSize["TextSize18"] = 18] = "TextSize18";
    TextSize[TextSize["TextSize20"] = 20] = "TextSize20";
    TextSize[TextSize["TextSize24"] = 24] = "TextSize24";
    TextSize[TextSize["TextSize28"] = 28] = "TextSize28";
    TextSize[TextSize["TextSize32"] = 32] = "TextSize32";
    TextSize[TextSize["TextSize36"] = 36] = "TextSize36";
    TextSize[TextSize["TextSize44"] = 44] = "TextSize44";
    TextSize[TextSize["TextSize48"] = 48] = "TextSize48";
    TextSize[TextSize["TextSize56"] = 56] = "TextSize56";
    TextSize[TextSize["TextSize60"] = 60] = "TextSize60";
    TextSize[TextSize["TextSize68"] = 68] = "TextSize68";
    TextSize[TextSize["TextSize72"] = 72] = "TextSize72";
    TextSize[TextSize["TextSize96"] = 96] = "TextSize96";
})(TextSize || (exports.TextSize = TextSize = {}));
var TextLineHeight;
(function (TextLineHeight) {
    TextLineHeight[TextLineHeight["TextLineHeight12"] = 12] = "TextLineHeight12";
    TextLineHeight[TextLineHeight["TextLineHeight14"] = 14] = "TextLineHeight14";
    TextLineHeight[TextLineHeight["TextLineHeight16"] = 16] = "TextLineHeight16";
    TextLineHeight[TextLineHeight["TextLineHeight18"] = 18] = "TextLineHeight18";
    TextLineHeight[TextLineHeight["TextLineHeight20"] = 20] = "TextLineHeight20";
    TextLineHeight[TextLineHeight["TextLineHeight22"] = 22] = "TextLineHeight22";
    TextLineHeight[TextLineHeight["TextLineHeight24"] = 24] = "TextLineHeight24";
    TextLineHeight[TextLineHeight["TextLineHeight25"] = 25] = "TextLineHeight25";
    TextLineHeight[TextLineHeight["TextLineHeight28"] = 28] = "TextLineHeight28";
    TextLineHeight[TextLineHeight["TextLineHeight29"] = 29] = "TextLineHeight29";
    TextLineHeight[TextLineHeight["TextLineHeight30"] = 30] = "TextLineHeight30";
    TextLineHeight[TextLineHeight["TextLineHeight32"] = 32] = "TextLineHeight32";
    TextLineHeight[TextLineHeight["TextLineHeight36"] = 36] = "TextLineHeight36";
    TextLineHeight[TextLineHeight["TextLineHeight40"] = 40] = "TextLineHeight40";
    TextLineHeight[TextLineHeight["TextLineHeight42"] = 42] = "TextLineHeight42";
    TextLineHeight[TextLineHeight["TextLineHeight44"] = 44] = "TextLineHeight44";
    TextLineHeight[TextLineHeight["TextLineHeight48"] = 48] = "TextLineHeight48";
    TextLineHeight[TextLineHeight["TextLineHeight52"] = 52] = "TextLineHeight52";
    TextLineHeight[TextLineHeight["TextLineHeight56"] = 56] = "TextLineHeight56";
    TextLineHeight[TextLineHeight["TextLineHeight60"] = 60] = "TextLineHeight60";
    TextLineHeight[TextLineHeight["TextLineHeight68"] = 68] = "TextLineHeight68";
    TextLineHeight[TextLineHeight["TextLineHeight72"] = 72] = "TextLineHeight72";
    TextLineHeight[TextLineHeight["TextLineHeight80"] = 80] = "TextLineHeight80";
    TextLineHeight[TextLineHeight["TextLineHeight96"] = 96] = "TextLineHeight96";
})(TextLineHeight || (exports.TextLineHeight = TextLineHeight = {}));
var TextType;
(function (TextType) {
    TextType["Headline"] = "headline";
    TextType["Label"] = "label";
    TextType["Copy"] = "copy";
})(TextType || (exports.TextType = TextType = {}));
